import { Text as UnstyledText } from 'features/common/components/Text';
import styled from 'styled-components';

export const Text = styled(UnstyledText)`
	font-style: normal;
	font-weight: 500;
	font-size: 24px;
	line-height: 153%;

	@media screen and (max-width: ${({ theme }) => theme.breakpoints.sm}) {
		font-size: 16px;
		line-height: 120%;
	}
`;

export const Container = styled.div`
	align-items: center;
	display: flex;
	height: 100vh;
	justify-content: center;
	left: 0;
	overflow: hidden;
	position: fixed;
	top: 0;
	width: 100%;
	z-index: 10001;
`;

export const Overlay = styled.div`
	align-items: center;
	height: 100%;
	left: 0;
	opacity: 0.5;
	overflow: auto;
	position: absolute;
	top: 0;
	width: 100%;
	background-color: ${({ theme }) => theme.colors.black || '#000'};
`;

export const ModalContent = styled.div<{ isWide?: boolean }>`
	background-color: #fff;
	border-radius: 16px;
	max-height: 90vh;
	margin: auto;
	width: ${({ isWide }) => (isWide ? '1400px' : '614px')};
	max-width: 95vw;
	margin-left: ${({ theme }) => theme.widths.hiddenSidebar};
	box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.15);
	position: relative;
	z-index: 10000;
	display: flex;
	flex-direction: column;

	@media screen and (max-width: 1400px) {
		width: ${({ isWide }) => (isWide ? '95vw' : '614px')};
		margin-left: ${({ isWide, theme }) => (isWide ? '0' : theme.widths.hiddenSidebar)};
	}

	@media screen and (max-width: ${({ theme }) => theme.breakpoints.sm}) {
		margin-left: 0;
		max-width: ${({ isWide }) => (isWide ? '95vw' : '614px')};
		width: calc(100vw - 64px);
	}
`;

export const HeaderContainer = styled.div<{ isPunchup: boolean }>`
	align-items: center;
	background-color: #fff;
	border-radius: 16px 16px 0 0;
	border-bottom: 1.5px solid #e5e5e5;
	color: #222;
	display: flex;
	flex-direction: row;
	font-family: ${({ theme }) => theme.fonts.primary};
	justify-content: center;
	height: 50px;
	padding: 0 24px;
	flex-shrink: 0;
`;

export const CloseButton = styled.div`
	cursor: pointer;
	height: 22px;
	width: 22px;
	color: #222;
`;

export const BodyContainer = styled.div`
	color: #222;
	padding: 0 55px;
	background-color: #fff;
	/* Scroll (not clip) so that when the card is capped to the mobile fold the body scrolls internally
	   while the header/footer stay pinned; min-height:0 lets this flex child shrink below its content. */
	overflow-x: hidden;
	overflow-y: auto;
	flex: 1;
	min-height: 0;
	display: flex;
	flex-direction: column;

	@media screen and (max-width: ${({ theme }) => theme.breakpoints.sm}) {
		padding: 0;
	}
`;

export const ActionsContainer = styled.div<{ isPunchup: boolean }>`
	background-color: #fff;
	border-radius: 0 0 16px 16px;
	border-top: 1.5px solid #e5e5e5;
	padding: 12px 24px;
	display: flex;
	justify-content: flex-end;
	gap: 12px;
	flex-shrink: 0;

	button {
		min-width: auto;
		padding: 8px 20px;
		font-size: 14px;
	}
`;
